module.exports = __webpack_public_path__ + "assets/search.5132bd91.svg";